module.exports = __webpack_public_path__ + "static/media/app_store.0f322512.png";